module.exports = __webpack_public_path__ + "img/opp-exclusive-service.97a20759.jpg";